import { Button } from '@repo/studio-design-system-ui-button'
import type { ButtonVariant } from '@repo/studio-design-system-ui-button'
import { Gift01Icon } from '@repo/studio-design-system-ui-icons/finance-ecommerce/gift-01'
import { ROUTES } from '@repo/studio-utils/routes'
import { useStudioTranslate } from '@repo/studio-config/studio-config-context'
import { StudioLayoutLink } from '@repo/studio-config/studio-config-router'

export function EarnMoreCoinsButton({
  variant = 'secondary',
  className,
}: {
  variant?: ButtonVariant
  className?: string
}) {
  const t = useStudioTranslate()

  return (
    <Button variant={variant} size="sm" className={className} asChild>
      <StudioLayoutLink to={ROUTES.REFERRALS.ROOT}>
        <Gift01Icon />
        {t('studio.home.earn_free_coins')}
      </StudioLayoutLink>
    </Button>
  )
}

export function EarnMoreCoinsIconButton({ variant = 'secondary' }: { variant?: ButtonVariant }) {
  const t = useStudioTranslate()

  return (
    <Button
      iconOnly
      aria-label={t('studio.home.earn_free_coins')}
      variant={variant}
      size="sm"
      asChild
    >
      <StudioLayoutLink to={ROUTES.REFERRALS.ROOT}>
        <Gift01Icon />
      </StudioLayoutLink>
    </Button>
  )
}
